interface OnboardingIntroStepProps {
  onContinue: () => void;
  onSignOut: () => void;
}

export function OnboardingIntroStep({
  onContinue,
  onSignOut,
}: OnboardingIntroStepProps) {
  return (
    <div className="flex flex-col h-full">
      {/* Scrollable content */}
      <div className="flex-1 overflow-y-auto autohide-scrollbar px-8 pt-4 pb-8">
        <div className="flex flex-col gap-6">
          <h1 className="text-h1 text-text-primary">
            Let's start something real.
          </h1>

          <p className="text-body-1 text-text-primary leading-relaxed">
            TinyClub is built for doing, not just posting. Start a club in
            seconds — for a few friends, a weekend plan, or something bigger.
            {"\n\n"}
            Already run a club? TinyClub keeps everyone connected and engaged in
            one place. No more juggling group chats, email lists, or extra tools.
          </p>

          <button
            onClick={onSignOut}
            className="text-body-2 text-text-tertiary underline self-start"
          >
            Sign out
          </button>
        </div>
      </div>

      {/* Footer */}
      <div className="flex-shrink-0 px-8 pb-6 pt-4 flex flex-col items-center gap-4">
        <button
          onClick={onContinue}
          className="w-full py-3.5 rounded-full bg-text-primary text-text-reversed text-body-1-medium font-medium hover:opacity-90 transition-opacity"
        >
          Continue
        </button>
        <p className="text-body-3 text-text-tertiary text-center">
          By continuing, you agree to our{" "}
          <a
            href="https://tiny.club/legal/terms-of-service"
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
          >
            Terms
          </a>
          ,{" "}
          <a
            href="https://tiny.club/legal/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
          >
            Privacy Policy
          </a>
          , and{" "}
          <a
            href="https://tiny.club/legal/community-guidelines"
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
          >
            Community Guidelines
          </a>
        </p>
      </div>
    </div>
  );
}
